module.exports = __webpack_public_path__ + "img/arrow-left-solid.0086f4de.svg";